import Button from '@mui/material/Button';

const BASE = {
  border: '1px solid var(--border)',
  background: 'var(--card)',
  borderRadius: '10px',
  padding: '8px 13px',
  color: 'var(--ink)',
  boxShadow: 'var(--shadow)',
  fontSize: 13,
  minWidth: 0,
  lineHeight: 1.4,
  textTransform: 'none',
  '&:hover': { background: 'var(--card-2)', borderColor: 'var(--border)' },
};

const TONES = {
  default: {},
  primary: {
    background: 'var(--side)',
    color: '#fff',
    borderColor: 'var(--side)',
    '&:hover': { background: 'var(--side-hi)', borderColor: 'var(--side-hi)' },
  },
  gold: {
    background: 'var(--gold)',
    color: '#2a2100',
    borderColor: 'var(--gold)',
    fontWeight: 600,
    '&:hover': { background: 'var(--gold-2)', borderColor: 'var(--gold-2)' },
  },
  danger: {
    color: 'var(--crit)',
    borderColor: '#e9c9c9',
    '&:hover': { background: '#fbeeee', borderColor: '#e9c9c9' },
  },
};

/**
 * The single button used across the app. `tone` picks the visual role,
 * `mini` matches the compact table-row size from the design.
 */
export default function AppButton({ tone = 'default', mini = false, sx, ...rest }) {
  return (
    <Button
      disableElevation
      sx={{
        ...BASE,
        ...TONES[tone],
        ...(mini ? { padding: '5px 9px', fontSize: 12 } : null),
        '&.Mui-disabled': { opacity: 0.45, color: 'var(--muted)' },
        ...sx,
      }}
      {...rest}
    />
  );
}
